import type { ProductDetail } from "./types";

export interface ProductDetail {
  id: string;
  nameEn: string;
  nameAr: string;
  slug: string;
  categoryId: string;
  price: number;
  compareAtPrice: number | null;
  rating: number;
  reviewCount: number;
  isNew: boolean;
  isSale: boolean;
  inStock: boolean;
  stockCount: number;
  images: string[];
  descriptionEn: string;
  descriptionAr: string;
  featuresEn: string[];
  featuresAr: string[];
  tags: string[];
  variants?: { name: string; options: string[] }[];
  reviews: {
    id: string;
    userName: string;
    userAvatar: string;
    rating: number;
    date: string;
    text: string;
  }[];
  createdAt: string;
}

export const allProducts: ProductDetail[] = [
  // Electronics (cat-1)
  {
    id: "prod-1",
    nameEn: "Wireless Noise-Canceling Headphones",
    nameAr: "سماعات لاسلكية عازلة للضوضاء",
    slug: "wireless-noise-canceling-headphones",
    categoryId: "cat-1",
    price: 129.99,
    compareAtPrice: 179.99,
    rating: 4.8,
    reviewCount: 234,
    isNew: false,
    isSale: true,
    inStock: true,
    stockCount: 45,
    images: [
      "https://readdy.ai/api/search-image?query=Premium%20wireless%20over-ear%20headphones%20in%20matte%20black%20on%20clean%20warm%20cream%20background%2C%20minimalist%20product%20photography%20with%20soft%20diffused%20studio%20lighting%2C%20front%20view&width=800&height=800&seq=prod-detail-hp-01&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Premium%20wireless%20headphones%20side%20profile%20view%20in%20matte%20black%20on%20clean%20warm%20cream%20background%2C%20minimalist%20product%20photography%20showing%20earcup%20detail%20with%20soft%20lighting&width=800&height=800&seq=prod-detail-hp-02&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Premium%20wireless%20headphones%20folded%20flat%20with%20carrying%20case%20accessories%20on%20clean%20warm%20cream%20background%2C%20lifestyle%20product%20photography%20with%20soft%20natural%20lighting&width=800&height=800&seq=prod-detail-hp-03&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Person%20wearing%20premium%20black%20wireless%20headphones%20in%20modern%20minimalist%20setting%20with%20warm%20lighting%2C%20lifestyle%20product%20photography%2C%20clean%20aesthetic&width=800&height=800&seq=prod-detail-hp-04&orientation=squarish",
    ],
    descriptionEn: "Experience premium sound with these wireless noise-canceling headphones. Featuring advanced active noise cancellation technology that blocks out ambient noise, 40-hour battery life, and ultra-comfortable memory foam ear cushions. Perfect for commuting, working, or simply enjoying your favorite music in peace.",
    descriptionAr: "استمتع بصوت ممتاز مع هذه السماعات اللاسلكية العازلة للضوضاء. تتميز بتقنية متقدمة لإلغاء الضوضاء النشطة تحجب الضوضاء المحيطة، وبطارية تدوم 40 ساعة، ووسائد أذن من الإسفنج الذكي فائقة الراحة. مثالية للتنقل أو العمل أو الاستمتاع بموسيقاك المفضلة بسلام.",
    featuresEn: ["Active Noise Cancellation", "40-hour battery life", "Bluetooth 5.3", "Memory foam ear cushions", "Built-in microphone", "Foldable design"],
    featuresAr: ["إلغاء الضوضاء النشط", "بطارية تدوم 40 ساعة", "بلوتوث 5.3", "وسائد إسفنج ذكي", "ميكروفون مدمج", "تصميم قابل للطي"],
    tags: ["headphones", "wireless", "audio", "noise-canceling", "bluetooth"],
    variants: [{ name: "Color", options: ["Matte Black", "Cream White", "Sage Green"] }],
    reviews: [
      { id: "r1", userName: "David Kim", userAvatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20headshot%20of%20a%20man%20on%20clean%20cream%20background%2C%20soft%20lighting&width=80&height=80&seq=rev-david&orientation=squarish", rating: 5, date: "2026-05-15", text: "Best headphones I've ever owned. The noise cancellation is incredible, and the battery lasts forever. Highly recommend!" },
      { id: "r2", userName: "Emma Wilson", userAvatar: "https://readdy.ai/api/search-image?query=Friendly%20portrait%20headshot%20of%20a%20woman%20on%20clean%20cream%20background%2C%20soft%20lighting&width=80&height=80&seq=rev-emma&orientation=squarish", rating: 4, date: "2026-05-10", text: "Great sound quality and very comfortable for long listening sessions. Only wish the case was a bit more compact." },
    ],
    createdAt: "2026-01-10",
  },
  {
    id: "prod-7",
    nameEn: "Portable Bluetooth Speaker",
    nameAr: "سماعة بلوتوث محمولة",
    slug: "portable-bluetooth-speaker",
    categoryId: "cat-1",
    price: 59.99,
    compareAtPrice: 79.99,
    rating: 4.4,
    reviewCount: 267,
    isNew: false,
    isSale: true,
    inStock: true,
    stockCount: 120,
    images: [
      "https://readdy.ai/api/search-image?query=Compact%20portable%20bluetooth%20speaker%20in%20warm%20sand%20color%20on%20clean%20cream%20background%2C%20minimalist%20product%20photography%20front%20view%20with%20soft%20lighting&width=800&height=800&seq=prod-detail-sp-01&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Portable%20bluetooth%20speaker%20angled%20side%20view%20showing%20control%20buttons%20on%20clean%20cream%20background%2C%20product%20photography%20with%20soft%20natural%20lighting&width=800&height=800&seq=prod-detail-sp-02&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Portable%20bluetooth%20speaker%20next%20to%20charging%20cable%20accessories%20on%20clean%20cream%20background%2C%20lifestyle%20product%20photography&width=800&height=800&seq=prod-detail-sp-03&orientation=squarish",
    ],
    descriptionEn: "Take your music anywhere with this compact yet powerful bluetooth speaker. Delivers rich, room-filling 360-degree sound with deep bass. Waterproof (IPX7 rating), dustproof, and built to withstand outdoor adventures. 20-hour battery keeps the music going all day.",
    descriptionAr: "خذ موسيقاك إلى أي مكان مع هذه السماعة البلوتوث المدمجة والقوية. تقدم صوتًا غنيًا بزاوية 360 درجة مع صوت جهير عميق. مقاومة للماء (تصنيف IPX7) ومقاومة للغبار ومصممة لتحمل المغامرات الخارجية. بطارية تدوم 20 ساعة تبقي الموسيقى مستمرة طوال اليوم.",
    featuresEn: ["360° immersive sound", "IPX7 waterproof", "20-hour battery", "Built-in microphone", "Bluetooth 5.2", "Ultra-portable design"],
    featuresAr: ["صوت غامر بزاوية 360°", "مقاوم للماء IPX7", "بطارية 20 ساعة", "ميكروفون مدمج", "بلوتوث 5.2", "تصميم فائق الحمل"],
    tags: ["speaker", "bluetooth", "portable", "waterproof", "audio"],
    variants: [{ name: "Color", options: ["Sand", "Charcoal", "Ocean Blue"] }],
    reviews: [
      { id: "r3", userName: "Mike Torres", userAvatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20headshot%20of%20a%20man%20on%20clean%20cream%20background%2C%20soft%20lighting&width=80&height=80&seq=rev-mike&orientation=squarish", rating: 5, date: "2026-04-22", text: "Amazing little speaker! Used it at the beach and by the pool — still going strong. Sound quality is impressive for its size." },
    ],
    createdAt: "2026-01-25",
  },
  {
    id: "prod-9",
    nameEn: "Smart Fitness Watch",
    nameAr: "ساعة لياقة ذكية",
    slug: "smart-fitness-watch",
    categoryId: "cat-1",
    price: 199.99,
    compareAtPrice: 249.99,
    rating: 4.6,
    reviewCount: 189,
    isNew: true,
    isSale: true,
    inStock: true,
    stockCount: 75,
    images: [
      "https://readdy.ai/api/search-image?query=Modern%20smart%20fitness%20watch%20with%20sleek%20design%20on%20clean%20warm%20cream%20background%2C%20minimalist%20product%20photography%20front%20view%20with%20soft%20lighting&width=800&height=800&seq=prod-detail-watch-01&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Smart%20fitness%20watch%20side%20view%20showing%20strap%20and%20sensors%20on%20clean%20cream%20background%2C%20product%20photography%20with%20soft%20natural%20lighting&width=800&height=800&seq=prod-detail-watch-02&orientation=squarish",
    ],
    descriptionEn: "Track your health and fitness with precision using this advanced smartwatch. Features heart rate monitoring, blood oxygen sensor, GPS tracking, sleep analysis, and over 100 workout modes. Crisp AMOLED display with always-on mode and 14-day battery life.",
    descriptionAr: "تتبع صحتك ولياقتك بدقة باستخدام هذه الساعة الذكية المتقدمة. تتميز بمراقبة معدل ضربات القلب ومستشعر الأكسجين في الدم وتتبع GPS وتحليل النوم وأكثر من 100 وضع تمرين. شاشة AMOLED واضحة مع وضع التشغيل الدائم وبطارية تدوم 14 يومًا.",
    featuresEn: ["Heart rate & SpO2 monitoring", "Built-in GPS", "100+ workout modes", "AMOLED always-on display", "14-day battery", "5ATM water resistance"],
    featuresAr: ["مراقبة معدل ضربات القلب والأكسجين", "GPS مدمج", "أكثر من 100 وضع تمرين", "شاشة AMOLED دائمة التشغيل", "بطارية 14 يوم", "مقاومة ماء 5ATM"],
    tags: ["smartwatch", "fitness", "health", "gps", "wearable"],
    variants: [{ name: "Size", options: ["40mm", "44mm"] }, { name: "Color", options: ["Midnight Black", "Starlight Silver"] }],
    reviews: [
      { id: "r4", userName: "Lisa Chang", userAvatar: "https://readdy.ai/api/search-image?query=Friendly%20portrait%20headshot%20of%20a%20woman%20on%20clean%20cream%20background%2C%20soft%20lighting&width=80&height=80&seq=rev-lisa&orientation=squarish", rating: 5, date: "2026-05-28", text: "Love this watch! The fitness tracking is super accurate and the battery actually lasts two weeks like they claim. Great value." },
      { id: "r5", userName: "Tom Baker", userAvatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20headshot%20of%20a%20man%20on%20clean%20cream%20background%2C%20soft%20lighting&width=80&height=80&seq=rev-tom&orientation=squarish", rating: 4, date: "2026-05-20", text: "Solid smartwatch for the price. GPS is reliable and the sleep tracking insights are really helpful." },
    ],
    createdAt: "2026-02-15",
  },
  // Fashion (cat-2)
  {
    id: "prod-2",
    nameEn: "Minimalist Leather Watch",
    nameAr: "ساعة جلدية بتصميم بسيط",
    slug: "minimalist-leather-watch",
    categoryId: "cat-2",
    price: 89.99,
    compareAtPrice: null,
    rating: 4.6,
    reviewCount: 189,
    isNew: true,
    isSale: false,
    inStock: true,
    stockCount: 35,
    images: [
      "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20leather%20strap%20watch%20with%20white%20dial%20on%20clean%20warm%20cream%20background%2C%20luxury%20product%20photography%20front%20view%20with%20soft%20studio%20lighting&width=800&height=800&seq=prod-detail-mw-01&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Elegant%20leather%20watch%20side%20view%20showing%20strap%20texture%20on%20clean%20cream%20background%2C%20product%20photography%20with%20soft%20lighting&width=800&height=800&seq=prod-detail-mw-02&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Person%20wearing%20elegant%20minimalist%20leather%20watch%20in%20casual%20setting%2C%20lifestyle%20product%20photography%20with%20warm%20natural%20lighting&width=800&height=800&seq=prod-detail-mw-03&orientation=squarish",
    ],
    descriptionEn: "A timeless piece crafted for the modern minimalist. Features a genuine Italian leather strap, Japanese quartz movement, and a scratch-resistant sapphire crystal face. The slim 7mm case sits elegantly on any wrist, making it perfect for both casual and formal occasions.",
    descriptionAr: "قطعة خالدة مصممة للبساطة العصرية. تتميز بحزام جلد إيطالي أصلي وحركة كوارتز يابانية ووجه كريستال ياقوتي مقاوم للخدش. العلبة النحيفة بسمك 7 مم تجلس بأناقة على أي معصم، مما يجعلها مثالية للمناسبات غير الرسمية والرسمية.",
    featuresEn: ["Italian leather strap", "Japanese quartz movement", "Sapphire crystal glass", "7mm slim case", "Water resistant 3ATM", "Interchangeable straps"],
    featuresAr: ["حزام جلد إيطالي", "حركة كوارتز يابانية", "زجاج كريستال ياقوتي", "علبة نحيفة 7 مم", "مقاومة ماء 3ATM", "أحزمة قابلة للتبديل"],
    tags: ["watch", "leather", "minimalist", "fashion", "accessories"],
    variants: [{ name: "Strap Color", options: ["Tan Brown", "Black", "Navy Blue"] }],
    reviews: [
      { id: "r6", userName: "Anna Peterson", userAvatar: "https://readdy.ai/api/search-image?query=Friendly%20portrait%20headshot%20of%20a%20woman%20on%20clean%20cream%20background%2C%20soft%20lighting&width=80&height=80&seq=rev-anna&orientation=squarish", rating: 5, date: "2026-06-01", text: "Absolutely gorgeous watch. The leather feels premium and the minimalist design gets so many compliments." },
    ],
    createdAt: "2026-02-01",
  },
  {
    id: "prod-8",
    nameEn: "Organic Cotton Tote Bag",
    nameAr: "حقيبة قطن عضوي",
    slug: "organic-cotton-tote-bag",
    categoryId: "cat-2",
    price: 24.99,
    compareAtPrice: null,
    rating: 4.3,
    reviewCount: 145,
    isNew: true,
    isSale: false,
    inStock: true,
    stockCount: 200,
    images: [
      "https://readdy.ai/api/search-image?query=Stylish%20organic%20cotton%20canvas%20tote%20bag%20in%20natural%20beige%20on%20clean%20warm%20cream%20background%2C%20minimalist%20product%20photography%20front%20view%20with%20soft%20lighting&width=800&height=800&seq=prod-detail-tote-01&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Organic%20cotton%20tote%20bag%20interior%20detail%20showing%20spacious%20compartment%20on%20clean%20cream%20background%2C%20product%20photography&width=800&height=800&seq=prod-detail-tote-02&orientation=squarish",
    ],
    descriptionEn: "An eco-friendly everyday essential made from 100% GOTS-certified organic cotton. Roomy enough for groceries, gym gear, or beach essentials with reinforced stitching for durability. Features an inner pocket for small items and comfortable wide shoulder straps.",
    descriptionAr: "ضرورة يومية صديقة للبيئة مصنوعة من قطن عضوي معتمد 100% GOTS. واسعة بما يكفي للبقالة أو معدات الصالة الرياضية أو أساسيات الشاطئ مع خياطة معززة للمتانة. تتميز بجيب داخلي للأشياء الصغيرة وأحزمة كتف عريضة مريحة.",
    featuresEn: ["100% organic cotton", "GOTS certified", "Reinforced stitching", "Inner zip pocket", "Wide shoulder straps", "Machine washable"],
    featuresAr: ["قطن عضوي 100%", "معتمد GOTS", "خياطة معززة", "جيب داخلي بسحاب", "أحزمة كتف عريضة", "قابل للغسل في الغسالة"],
    tags: ["tote", "bag", "organic", "cotton", "eco-friendly", "fashion"],
    variants: [{ name: "Color", options: ["Natural", "Charcoal", "Sage"] }],
    reviews: [],
    createdAt: "2026-02-20",
  },
  {
    id: "prod-10",
    nameEn: "Classic Aviator Sunglasses",
    nameAr: "نظارات طيار كلاسيكية",
    slug: "classic-aviator-sunglasses",
    categoryId: "cat-2",
    price: 69.99,
    compareAtPrice: 89.99,
    rating: 4.5,
    reviewCount: 312,
    isNew: false,
    isSale: true,
    inStock: true,
    stockCount: 90,
    images: [
      "https://readdy.ai/api/search-image?query=Classic%20aviator%20sunglasses%20with%20gold%20frame%20on%20clean%20warm%20cream%20background%2C%20minimalist%20product%20photography%20front%20view%20with%20soft%20lighting&width=800&height=800&seq=prod-detail-sung-01&orientation=squarish",
    ],
    descriptionEn: "Timeless aviator sunglasses with polarized UV400 lenses that provide superior eye protection. Lightweight metal frame with adjustable nose pads ensures all-day comfort. Comes with a premium hard case and microfiber cleaning cloth.",
    descriptionAr: "نظارات طيار خالدة بعدسات مستقطبة UV400 توفر حماية فائقة للعين. إطار معدني خفيف الوزن مع وسادات أنف قابلة للتعديل يضمن الراحة طوال اليوم. تأتي مع حقيبة صلبة فاخرة وقماش تنظيف من الألياف الدقيقة.",
    featuresEn: ["Polarized UV400 lenses", "Lightweight metal frame", "Adjustable nose pads", "Scratch-resistant coating", "Includes hard case"],
    featuresAr: ["عدسات مستقطبة UV400", "إطار معدني خفيف", "وسادات أنف قابلة للتعديل", "طلاء مقاوم للخدش", "تشمل حقيبة صلبة"],
    tags: ["sunglasses", "aviator", "polarized", "fashion", "accessories"],
    variants: [{ name: "Frame", options: ["Gold", "Silver", "Rose Gold"] }, { name: "Lens", options: ["Green", "Brown", "Grey"] }],
    reviews: [
      { id: "r7", userName: "Chris Nolan", userAvatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20headshot%20of%20a%20man%20on%20clean%20cream%20background%2C%20soft%20lighting&width=80&height=80&seq=rev-chris&orientation=squarish", rating: 4, date: "2026-05-05", text: "Classic look, great quality lenses. The polarization really helps with glare while driving." },
    ],
    createdAt: "2026-03-01",
  },
  // Home & Living (cat-3)
  {
    id: "prod-3",
    nameEn: "Ceramic Aroma Diffuser",
    nameAr: "موزع عطر سيراميك",
    slug: "ceramic-aroma-diffuser",
    categoryId: "cat-3",
    price: 45.99,
    compareAtPrice: 59.99,
    rating: 4.7,
    reviewCount: 156,
    isNew: false,
    isSale: true,
    inStock: true,
    stockCount: 55,
    images: [
      "https://readdy.ai/api/search-image?query=Modern%20ceramic%20essential%20oil%20diffuser%20in%20warm%20terracotta%20on%20clean%20cream%20background%2C%20minimalist%20product%20photography%20front%20view%20with%20soft%20lighting&width=800&height=800&seq=prod-detail-diff-01&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Ceramic%20aroma%20diffuser%20with%20gentle%20mist%20in%20cozy%20home%20setting%2C%20lifestyle%20photography%20with%20warm%20natural%20lighting&width=800&height=800&seq=prod-detail-diff-02&orientation=squarish",
    ],
    descriptionEn: "Transform your space with this handcrafted ceramic aroma diffuser. Uses ultrasonic technology to create a fine, cool mist that disperses your favorite essential oils throughout the room. Features auto shut-off, adjustable mist settings, and a warm ambient LED light. 300ml capacity runs up to 10 hours.",
    descriptionAr: "حول مساحتك مع موزع العطر السيراميكي المصنوع يدويًا. يستخدم تقنية الموجات فوق الصوتية لإنشاء رذاذ بارد ناعم ينشر زيوتك العطرية المفضلة في جميع أنحاء الغرفة. يتميز بإيقاف تلقائي وإعدادات رذاذ قابلة للتعديل وضوء LED محيط دافئ. سعة 300 مل تعمل حتى 10 ساعات.",
    featuresEn: ["Ultrasonic technology", "300ml capacity", "Auto shut-off", "Adjustable mist", "LED ambient light", "Handcrafted ceramic"],
    featuresAr: ["تقنية الموجات فوق الصوتية", "سعة 300 مل", "إيقاف تلقائي", "رذاذ قابل للتعديل", "ضوء LED محيط", "سيراميك مصنوع يدويًا"],
    tags: ["diffuser", "aroma", "ceramic", "home", "essential oils", "wellness"],
    variants: [{ name: "Color", options: ["Terracotta", "Ivory White", "Sage Green"] }],
    reviews: [
      { id: "r8", userName: "Rachel Green", userAvatar: "https://readdy.ai/api/search-image?query=Friendly%20portrait%20headshot%20of%20a%20woman%20on%20clean%20cream%20background%2C%20soft%20lighting&width=80&height=80&seq=rev-rachel&orientation=squarish", rating: 5, date: "2026-04-18", text: "This diffuser is beautiful AND functional. The ceramic finish looks like a piece of art on my shelf. Very quiet operation too." },
    ],
    createdAt: "2026-01-18",
  },
  {
    id: "prod-11",
    nameEn: "Linen Throw Blanket",
    nameAr: "بطانية كتان",
    slug: "linen-throw-blanket",
    categoryId: "cat-3",
    price: 64.99,
    compareAtPrice: null,
    rating: 4.8,
    reviewCount: 98,
    isNew: true,
    isSale: false,
    inStock: true,
    stockCount: 40,
    images: [
      "https://readdy.ai/api/search-image?query=Luxurious%20linen%20throw%20blanket%20draped%20elegantly%20on%20a%20sofa%20in%20warm%20neutral%20tones%2C%20lifestyle%20product%20photography%20with%20soft%20natural%20lighting&width=800&height=800&seq=prod-detail-blank-01&orientation=squarish",
    ],
    descriptionEn: "Wrap yourself in pure comfort with this 100% European flax linen throw blanket. Pre-washed for an incredibly soft hand feel that gets better with every wash. The natural temperature-regulating properties keep you cozy in winter and cool in summer. Finished with delicate fringe detailing.",
    descriptionAr: "لف نفسك في راحة نقية مع بطانية الكتان المصنوعة من الكتان الأوروبي 100%. مغسولة مسبقًا للحصول على ملمس ناعم بشكل لا يصدق يتحسن مع كل غسلة. خصائص تنظيم درجة الحرارة الطبيعية تبقيك دافئًا في الشتاء وباردًا في الصيف. منتهية بتفاصيل هامشية دقيقة.",
    featuresEn: ["100% European flax linen", "Pre-washed softness", "Temperature regulating", "Fringe detailing", "OEKO-TEX certified", "130 x 180 cm"],
    featuresAr: ["كتان أوروبي 100%", "نعومة مغسولة مسبقًا", "تنظيم درجة الحرارة", "تفاصيل هامشية", "معتمد OEKO-TEX", "130 × 180 سم"],
    tags: ["blanket", "linen", "throw", "home", "textiles", "cozy"],
    variants: [{ name: "Color", options: ["Oatmeal", "Dusty Rose", "Sage", "Charcoal"] }],
    reviews: [],
    createdAt: "2026-03-10",
  },
  // Beauty (cat-4)
  {
    id: "prod-4",
    nameEn: "Vitamin C Brightening Serum",
    nameAr: "سيروم فيتامين سي للتفتيح",
    slug: "vitamin-c-brightening-serum",
    categoryId: "cat-4",
    price: 34.99,
    compareAtPrice: null,
    rating: 4.9,
    reviewCount: 312,
    isNew: false,
    isSale: false,
    inStock: true,
    stockCount: 150,
    images: [
      "https://readdy.ai/api/search-image?query=Premium%20vitamin%20C%20serum%20in%20amber%20glass%20bottle%20with%20dropper%20on%20clean%20warm%20cream%20background%2C%20luxury%20skincare%20product%20photography%20front%20view&width=800&height=800&seq=prod-detail-serum-01&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Vitamin%20C%20serum%20with%20natural%20ingredients%20like%20citrus%20fruits%20around%20it%20on%20clean%20warm%20cream%20background%2C%20lifestyle%20skincare%20photography&width=800&height=800&seq=prod-detail-serum-02&orientation=squarish",
    ],
    descriptionEn: "This potent Vitamin C serum combines 15% L-ascorbic acid with vitamin E and ferulic acid for maximum antioxidant protection. Clinically proven to brighten skin tone, reduce dark spots, and boost collagen production. Lightweight, fast-absorbing formula suitable for all skin types.",
    descriptionAr: "يجمع سيروم فيتامين سي القوي هذا بين 15% حمض الأسكوربيك L مع فيتامين E وحمض الفيروليك للحصول على أقصى حماية مضادة للأكسدة. مثبت سريريًا لتفتيح لون البشرة وتقليل البقع الداكنة وتعزيز إنتاج الكولاجين. تركيبة خفيفة وسريعة الامتصاص مناسبة لجميع أنواع البشرة.",
    featuresEn: ["15% L-ascorbic acid", "Vitamin E + Ferulic acid", "Brightens & evens tone", "Boosts collagen", "All skin types", "Dermatologist tested"],
    featuresAr: ["15% حمض الأسكوربيك L", "فيتامين E + حمض الفيروليك", "يفتح ويوحد اللون", "يعزز الكولاجين", "جميع أنواع البشرة", "مختبر من أطباء الجلد"],
    tags: ["serum", "vitamin c", "skincare", "brightening", "beauty", "antioxidant"],
    variants: [{ name: "Size", options: ["30ml", "50ml"] }],
    reviews: [
      { id: "r9", userName: "Maria Santos", userAvatar: "https://readdy.ai/api/search-image?query=Friendly%20portrait%20headshot%20of%20a%20woman%20on%20clean%20cream%20background%2C%20soft%20lighting&width=80&height=80&seq=rev-maria&orientation=squarish", rating: 5, date: "2026-06-05", text: "My holy grail serum! Been using it for 3 months and my dark spots have visibly faded. Skin feels so much brighter." },
      { id: "r10", userName: "Jennifer Lee", userAvatar: "https://readdy.ai/api/search-image?query=Friendly%20portrait%20headshot%20of%20a%20woman%20on%20clean%20cream%20background%2C%20soft%20lighting&width=80&height=80&seq=rev-jennifer&orientation=squarish", rating: 5, date: "2026-05-30", text: "Best vitamin C I've tried. Doesn't irritate my sensitive skin and absorbs beautifully under moisturizer." },
    ],
    createdAt: "2026-01-05",
  },
  {
    id: "prod-12",
    nameEn: "Natural Lip Balm Set",
    nameAr: "مجموعة مرطب شفاه طبيعي",
    slug: "natural-lip-balm-set",
    categoryId: "cat-4",
    price: 16.99,
    compareAtPrice: 22.99,
    rating: 4.7,
    reviewCount: 203,
    isNew: false,
    isSale: true,
    inStock: true,
    stockCount: 300,
    images: [
      "https://readdy.ai/api/search-image?query=Set%20of%20natural%20lip%20balms%20in%20small%20tins%20arranged%20neatly%20on%20clean%20warm%20cream%20background%2C%20minimalist%20product%20photography%20with%20soft%20lighting&width=800&height=800&seq=prod-detail-lip-01&orientation=squarish",
    ],
    descriptionEn: "A trio of nourishing lip balms made with organic beeswax, shea butter, and coconut oil. Three naturally derived flavors: vanilla bean, wild berry, and peppermint. Deeply hydrating formula that protects lips from harsh weather while leaving a subtle, natural sheen.",
    descriptionAr: "ثلاثي من مرطبات الشفاه المغذية المصنوعة من شمع العسل العضوي وزبدة الشيا وزيت جوز الهند. ثلاث نكهات طبيعية: الفانيليا والتوت البري والنعناع. تركيبة مرطبة بعمق تحمي الشفاه من الطقس القاسي مع ترك لمعان طبيعي خفيف.",
    featuresEn: ["Organic beeswax base", "Shea butter & coconut oil", "Three natural flavors", "Long-lasting hydration", "No artificial colors", "Cruelty-free"],
    featuresAr: ["قاعدة شمع عسل عضوي", "زبدة الشيا وزيت جوز الهند", "ثلاث نكهات طبيعية", "ترطيب طويل الأمد", "بدون ألوان صناعية", "خالٍ من القسوة"],
    tags: ["lip balm", "natural", "organic", "skincare", "beauty", "gift set"],
    variants: [],
    reviews: [
      { id: "r11", userName: "Sophie Martin", userAvatar: "https://readdy.ai/api/search-image?query=Friendly%20portrait%20headshot%20of%20a%20woman%20on%20clean%20cream%20background%2C%20soft%20lighting&width=80&height=80&seq=rev-sophie&orientation=squarish", rating: 5, date: "2026-05-12", text: "These are the best lip balms I've ever used. The vanilla one is my absolute favorite — so creamy and long-lasting." },
    ],
    createdAt: "2026-03-20",
  },
  // Sports & Outdoors (cat-5)
  {
    id: "prod-5",
    nameEn: "Insulated Stainless Steel Bottle",
    nameAr: "زجاجة ستانلس ستيل معزولة",
    slug: "insulated-stainless-steel-bottle",
    categoryId: "cat-5",
    price: 28.99,
    compareAtPrice: 39.99,
    rating: 4.5,
    reviewCount: 178,
    isNew: true,
    isSale: true,
    inStock: true,
    stockCount: 250,
    images: [
      "https://readdy.ai/api/search-image?query=Sleek%20stainless%20steel%20insulated%20water%20bottle%20in%20matte%20finish%20on%20clean%20warm%20cream%20background%2C%20minimalist%20product%20photography%20front%20view&width=800&height=800&seq=prod-detail-bottle-01&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Stainless%20steel%20water%20bottle%20in%20gym%20setting%20next%20to%20yoga%20mat%2C%20lifestyle%20product%20photography%20with%20natural%20lighting&width=800&height=800&seq=prod-detail-bottle-02&orientation=squarish",
    ],
    descriptionEn: "Stay hydrated in style with this double-wall vacuum insulated water bottle. Keeps drinks cold for 24 hours or hot for 12 hours. Made from premium 18/8 stainless steel with a sweat-proof matte finish. BPA-free sports cap with leak-proof seal and wide mouth for easy cleaning.",
    descriptionAr: "حافظ على ترطيبك بأناقة مع زجاجة الماء المعزولة مزدوجة الجدار بتقنية التفريغ. تحافظ على المشروبات باردة لمدة 24 ساعة أو ساخنة لمدة 12 ساعة. مصنوعة من الفولاذ المقاوم للصدأ 18/8 الفاخر بلمسة نهائية غير لامعة مقاومة للتعرق. غطاء رياضي خالٍ من BPA مع ختم مانع للتسرب وفم واسع لسهولة التنظيف.",
    featuresEn: ["Double-wall vacuum insulation", "24h cold / 12h hot", "18/8 stainless steel", "BPA-free sports cap", "Leak-proof design", "750ml capacity"],
    featuresAr: ["عزل مزدوج الجدار بالتفريغ", "بارد 24 ساعة / ساخن 12 ساعة", "فولاذ 18/8 مقاوم للصدأ", "غطاء رياضي خالٍ من BPA", "تصميم مانع للتسرب", "سعة 750 مل"],
    tags: ["water bottle", "insulated", "stainless steel", "sports", "hydration", "eco-friendly"],
    variants: [{ name: "Color", options: ["Matte Black", "Sage Green", "Terracotta", "Navy"] }, { name: "Size", options: ["500ml", "750ml", "1L"] }],
    reviews: [
      { id: "r12", userName: "Jake Williams", userAvatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20headshot%20of%20a%20man%20on%20clean%20cream%20background%2C%20soft%20lighting&width=80&height=80&seq=rev-jake&orientation=squarish", rating: 4, date: "2026-04-30", text: "Great bottle, keeps my water cold all day at the office and during workouts. The matte finish feels premium." },
    ],
    createdAt: "2026-02-10",
  },
  {
    id: "prod-13",
    nameEn: "Cork Yoga Mat",
    nameAr: "سجادة يوغا من الفلين",
    slug: "cork-yoga-mat",
    categoryId: "cat-5",
    price: 54.99,
    compareAtPrice: null,
    rating: 4.6,
    reviewCount: 87,
    isNew: true,
    isSale: false,
    inStock: true,
    stockCount: 60,
    images: [
      "https://readdy.ai/api/search-image?query=Premium%20cork%20yoga%20mat%20rolled%20and%20unrolled%20on%20clean%20warm%20cream%20background%2C%20minimalist%20product%20photography%20with%20soft%20natural%20lighting&width=800&height=800&seq=prod-detail-yoga-01&orientation=squarish",
    ],
    descriptionEn: "An eco-conscious yoga mat made from sustainable cork and natural tree rubber. The cork surface provides excellent grip that actually improves when wet, making it perfect for hot yoga. Naturally antimicrobial and easy to clean. 6mm thickness offers ideal cushioning for joints.",
    descriptionAr: "سجادة يوغا صديقة للبيئة مصنوعة من الفلين المستدام والمطاط الطبيعي. يوفر سطح الفلين قبضة ممتازة تتحسن عند البلل، مما يجعلها مثالية لليوغا الساخنة. مضادة للميكروبات بشكل طبيعي وسهلة التنظيف. سمك 6 مم يوفر توسيدًا مثاليًا للمفاصل.",
    featuresEn: ["Sustainable cork surface", "Natural rubber base", "Antimicrobial", "Superior wet grip", "6mm cushioning", "Includes carry strap"],
    featuresAr: ["سطح فلين مستدام", "قاعدة مطاط طبيعي", "مضاد للميكروبات", "قبضة مبللة فائقة", "توسيد 6 مم", "يشمل حزام حمل"],
    tags: ["yoga", "mat", "cork", "eco-friendly", "fitness", "sports"],
    variants: [],
    reviews: [],
    createdAt: "2026-03-25",
  },
  // Kitchen & Dining (cat-6)
  {
    id: "prod-6",
    nameEn: "Japanese Chef Knife Set",
    nameAr: "مجموعة سكاكين طاهٍ يابانية",
    slug: "japanese-chef-knife-set",
    categoryId: "cat-6",
    price: 149.99,
    compareAtPrice: null,
    rating: 4.8,
    reviewCount: 92,
    isNew: false,
    isSale: false,
    inStock: true,
    stockCount: 25,
    images: [
      "https://readdy.ai/api/search-image?query=Premium%20Japanese%20chef%20knife%20set%20on%20wooden%20magnetic%20block%20on%20clean%20warm%20cream%20background%2C%20professional%20product%20photography%20front%20view&width=800&height=800&seq=prod-detail-knife-01&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20Japanese%20chef%20knife%20showing%20damascus%20steel%20pattern%20on%20clean%20cream%20background%2C%20detail%20product%20photography&width=800&height=800&seq=prod-detail-knife-02&orientation=squarish",
    ],
    descriptionEn: "Elevate your culinary experience with this premium 5-piece Japanese knife set. Each blade is crafted from 67-layer Damascus steel with a VG-10 core, hardened to 60±2 HRC for exceptional edge retention. The ergonomic pakkawood handles provide perfect balance and control. Includes chef's knife, santoku, utility, paring knife, and a magnetic acacia wood block.",
    descriptionAr: "ارتقِ بتجربتك في الطهي مع مجموعة السكاكين اليابانية الفاخرة المكونة من 5 قطع. كل شفرة مصنوعة من فولاذ دمشق 67 طبقة مع نواة VG-10، مصلدة إلى 60±2 HRC لاحتفاظ استثنائي بالحافة. توفر المقابض المريحة من خشب الباكا توازنًا وتحكمًا مثاليين. تشمل سكين طاهٍ وسكين سانتوكو وسكين متعدد الاستخدامات وسكين تقشير وكتلة أكاسيا مغناطيسية.",
    featuresEn: ["67-layer Damascus steel", "VG-10 Japanese steel core", "60±2 HRC hardness", "Pakkawood handles", "Magnetic acacia block", "5-piece set"],
    featuresAr: ["فولاذ دمشق 67 طبقة", "نواة فولاذ ياباني VG-10", "صلابة 60±2 HRC", "مقابض خشب الباكا", "كتلة أكاسيا مغناطيسية", "مجموعة 5 قطع"],
    tags: ["knife", "japanese", "chef", "kitchen", "damascus", "cooking"],
    variants: [],
    reviews: [
      { id: "r13", userName: "Chef Marco", userAvatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20headshot%20of%20a%20man%20on%20clean%20cream%20background%2C%20soft%20lighting&width=80&height=80&seq=rev-marco&orientation=squarish", rating: 5, date: "2026-05-18", text: "These knives are phenomenal. Razor sharp out of the box and the balance is perfect. The Damascus pattern is stunning." },
      { id: "r14", userName: "Priya Patel", userAvatar: "https://readdy.ai/api/search-image?query=Friendly%20portrait%20headshot%20of%20a%20woman%20on%20clean%20cream%20background%2C%20soft%20lighting&width=80&height=80&seq=rev-priya&orientation=squarish", rating: 5, date: "2026-05-08", text: "Worth every penny. The magnetic block looks beautiful on my counter and the knives make cooking so much more enjoyable." },
    ],
    createdAt: "2026-01-30",
  },
  {
    id: "prod-14",
    nameEn: "Cast Iron Dutch Oven",
    nameAr: "قدر هولندي من الحديد الزهر",
    slug: "cast-iron-dutch-oven",
    categoryId: "cat-6",
    price: 79.99,
    compareAtPrice: 99.99,
    rating: 4.9,
    reviewCount: 156,
    isNew: false,
    isSale: true,
    inStock: true,
    stockCount: 30,
    images: [
      "https://readdy.ai/api/search-image?query=Beautiful%20enameled%20cast%20iron%20dutch%20oven%20in%20warm%20cream%20color%20on%20clean%20background%2C%20minimalist%20kitchen%20product%20photography%20with%20soft%20lighting&width=800&height=800&seq=prod-detail-oven-01&orientation=squarish",
    ],
    descriptionEn: "A kitchen workhorse that will last for generations. This enameled cast iron Dutch oven delivers superior heat retention and even distribution for perfect braises, stews, soups, and bread. The durable enamel finish resists chipping and requires no seasoning. Oven-safe to 500°F and suitable for all cooktops including induction.",
    descriptionAr: "حصان عمل في المطبخ سيدوم لأجيال. يقدم هذا القدر الهولندي المصنوع من الحديد الزهر المطلي بالمينا احتفاظًا فائقًا بالحرارة وتوزيعًا متساويًا للطهي المثالي واليخنات والحساء والخبز. الطبقة النهائية من المينا المتينة تقاوم التقطيع ولا تتطلب تتبيلًا. آمن للفرن حتى 500 درجة فهرنهايت ومناسب لجميع أنواع المواقد بما في ذلك الحث.",
    featuresEn: ["Enameled cast iron", "Superior heat retention", "Oven-safe to 500°F", "No seasoning needed", "All cooktops (incl. induction)", "5.5 quart capacity"],
    featuresAr: ["حديد زهر مطلي بالمينا", "احتفاظ فائق بالحرارة", "آمن للفرن حتى 500°ف", "لا حاجة للتتبيل", "جميع المواقد (بما في ذلك الحث)", "سعة 5.5 لتر"],
    tags: ["dutch oven", "cast iron", "cookware", "kitchen", "enameled", "cooking"],
    variants: [{ name: "Color", options: ["Cream", "Sage Green", "Terracotta", "Navy Blue"] }, { name: "Size", options: ["4.5 qt", "5.5 qt", "7 qt"] }],
    reviews: [
      { id: "r15", userName: "HomeCook Nina", userAvatar: "https://readdy.ai/api/search-image?query=Friendly%20portrait%20headshot%20of%20a%20woman%20on%20clean%20cream%20background%2C%20soft%20lighting&width=80&height=80&seq=rev-nina&orientation=squarish", rating: 5, date: "2026-06-10", text: "I use this almost every day! From sourdough bread to slow-cooked stews, it handles everything beautifully. The cream color looks gorgeous on my stovetop." },
    ],
    createdAt: "2026-02-25",
  },
  {
    id: "prod-15",
    nameEn: "Bamboo Cutting Board Set",
    nameAr: "مجموعة ألواح تقطيع من الخيزران",
    slug: "bamboo-cutting-board-set",
    categoryId: "cat-6",
    price: 34.99,
    compareAtPrice: 44.99,
    rating: 4.4,
    reviewCount: 221,
    isNew: false,
    isSale: true,
    inStock: true,
    stockCount: 110,
    images: [
      "https://readdy.ai/api/search-image?query=Set%20of%20three%20bamboo%20cutting%20boards%20in%20different%20sizes%20stacked%20on%20clean%20warm%20cream%20background%2C%20minimalist%20kitchen%20product%20photography&width=800&height=800&seq=prod-detail-board-01&orientation=squarish",
    ],
    descriptionEn: "A versatile set of three organic bamboo cutting boards in small, medium, and large sizes. Naturally antimicrobial and gentler on knife edges than plastic or glass. Features deep juice grooves for mess-free prep and easy-grip handles. Made from sustainably harvested Moso bamboo.",
    descriptionAr: "مجموعة متعددة الاستخدامات من ثلاث ألواح تقطيع من الخيزران العضوي بأحجام صغيرة ومتوسطة وكبيرة. مضادة للميكروبات بشكل طبيعي وألطف على حواف السكاكين من البلاستيك أو الزجاج. تتميز بأخاديد عميقة للعصائر لتحضير خالٍ من الفوضى ومقابض سهلة الإمساك. مصنوعة من خيزران موسو المحصود بشكل مستدام.",
    featuresEn: ["Organic Moso bamboo", "3 sizes (S/M/L)", "Antimicrobial", "Knife-friendly surface", "Juice grooves", "Sustainably harvested"],
    featuresAr: ["خيزران موسو عضوي", "3 أحجام (ص/م/ك)", "مضاد للميكروبات", "سطح صديق للسكاكين", "أخاديد عصائر", "محصود بشكل مستدام"],
    tags: ["cutting board", "bamboo", "kitchen", "eco-friendly", "cooking"],
    variants: [],
    reviews: [
      { id: "r16", userName: "Daniel Hart", userAvatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20headshot%20of%20a%20man%20on%20clean%20cream%20background%2C%20soft%20lighting&width=80&height=80&seq=rev-daniel&orientation=squarish", rating: 4, date: "2026-04-15", text: "Nice set of boards. Love that there are three sizes for different tasks. They've held up well after months of use." },
    ],
    createdAt: "2026-03-15",
  },
];

export const featuredProducts = allProducts.filter((p) =>
  ["prod-1", "prod-2", "prod-3", "prod-4", "prod-5", "prod-6", "prod-7", "prod-8"].includes(p.id)
);

export const testimonialData = [
  {
    id: "test-1",
    name: "Sarah Mitchell",
    role: "Verified Buyer",
    avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20woman%20in%20her%2030s%20with%20warm%20smile%2C%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20headshot%20style&width=200&height=200&seq=avatar-sarah-01&orientation=squarish",
    rating: 5,
    text: "I've been shopping here for over a year now and the quality never disappoints. Fast shipping and great customer service make all the difference.",
    textAr: "لقد كنت أتسوق هنا لأكثر من عام والجودة لا تخيب أبدًا. الشحن السريع وخدمة العملاء الرائعة تصنع الفرق.",
  },
  {
    id: "test-2",
    name: "James Rodriguez",
    role: "Loyal Customer",
    avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20man%20in%20his%2030s%20with%20confident%20expression%2C%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20headshot%20style&width=200&height=200&seq=avatar-james-02&orientation=squarish",
    rating: 5,
    text: "The product variety is incredible. I always find exactly what I need, and the prices are unbeatable compared to other stores.",
    textAr: "تنوع المنتجات مذهل. أجد دائمًا ما أحتاجه بالضبط، والأسعار لا تقبل المنافسة مقارنة بالمتاجر الأخرى.",
  },
  {
    id: "test-3",
    name: "Aisha Rahman",
    role: "Verified Buyer",
    avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20woman%20in%20her%20late%2020s%20with%20friendly%20smile%2C%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20headshot%20style&width=200&height=200&seq=avatar-aisha-03&orientation=squarish",
    rating: 5,
    text: "Customer support is outstanding. They helped me with a return and had it sorted within hours. This is my go-to store now.",
    textAr: "دعم العملاء رائع. ساعدوني في عملية إرجاع وأنهوها في غضون ساعات. هذا متجري المفضل الآن.",
  },
];